export const breakpoints = {
    breakpointxs: 375,
    breakpointsm: 768,
    breakpointmd: 1280,
    breakpointlg: 1440
};